export default __webpack_public_path__ + "static/media/COVID-symptoms.3fe3a2c6.png";